import {
  Component,
  ChangeDetectionStrategy,
  Input,
  TemplateRef,
  Output,
  EventEmitter,
  HostBinding,
} from '@angular/core';

import { GasIcon } from '../../utils/gas-icons/icon/gas-icon.namespace';
import { GasSize } from '../../core/sizes/gas-size.enum';
import { GasCard } from './gas-card.namespace';
import { GasInputBoolean } from '@cikrf/gas-utils/decorators';

/**
 * @description Component implements standard logical block.
 * @param type (default | maxi) - define padding.
 * @param title - define block title.
 * @param button - define standard button caption.
 * @param inputTemplate - button template that will be rendered.
 * @param buttonIcon - define footer button icon with, uses gas-icon icon preset.
 * @param isLoader - define loader visibility status.
 * @param buttonType - define card footer type (default/ brand/ positive/ destructive)
 * @exapmle <gas-card type="maxi" title="title-string" button="btn-string"> content-text-string <gas-card>
 * @example <gas-card [inputTemplate]="tmp"></gas-card>
 * <ng-templaete #tmp></ng-template>
 */
@Component({
  selector: 'gas-card',
  templateUrl: './gas-card.component.html',
  styleUrls: ['./gas-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasCardComponent {
  @Input()
  public type: GasCard.SpacingType | string;

  @Input()
  public title: string;

  @Input()
  public button: string;

  @Input()
  public inputTemplate: TemplateRef<void>;

  @Input()
  public infoContent: TemplateRef<void>;

  @Input()
  public buttonIcon: GasIcon.Icons;

  @Input()
  public isLoader = false;

  @Input()
  public buttonType: GasCard.ButtonType;

  @Input()
  @GasInputBoolean()
  @HostBinding('class._disabled')
  public disabled: string | boolean = false;

  /** Имя иконки */
  @Input()
  public iconName: GasIcon.Icons | string;

  /** Имя класса иконки для установки цвета */
  @Input()
  public iconClass: string;

  @Output()
  public onClick = new EventEmitter();

  @HostBinding('class._default')
  public get classDefault(): boolean {
    return this.type === GasCard.SpacingType.Default;
  }

  @HostBinding('class._small')
  public get classSmall(): boolean {
    return this.type === GasCard.SpacingType.Small;
  }

  @HostBinding('class._maxi')
  public get classMaxi(): boolean {
    return this.type === GasCard.SpacingType.Maxi;
  }

  @HostBinding('class._info')
  public get infoCard(): boolean {
    return this.type === GasCard.SpacingType.Info;
  }

  @HostBinding('class._actions')
  public get actionCard(): boolean {
    return this.type === GasCard.SpacingType.Actions;
  }

  public iconSize = GasSize.MdSize;

  constructor() { }
}
